import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VendorCommission } from '../../model/commission';

export type VendorCommissionState = {
  data: VendorCommission[];
  loading: boolean;
  error: string | null;
  updating: boolean;
  updateError: string | null;
  updateSuccess: string | null;
  toggleValue: number;
};

const initialState: VendorCommissionState = {
  data: [],
  loading: false,
  error: null,
  updating: false,
  updateError: null,
  updateSuccess: null,
  toggleValue: 0,
};

const slice = createSlice({
  name: 'vendorCommission',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action: PayloadAction<VendorCommission[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    fetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    updateStart: (state) => {
      state.updating = true;
      state.updateError = null;
      state.updateSuccess = null;
    },
    updateSuccess: (
      state,
      action: PayloadAction<{ vendor_id: number; new_percentage: number; message: string }>
    ) => {
      state.updating = false;
      state.updateSuccess = action.payload.message;
      // Update the record in-place so the list reflects the new value immediately
      const idx = state.data.findIndex((v) => v.vendor_id === action.payload.vendor_id);
      if (idx !== -1) {
        state.data[idx].commission_percentage = action.payload.new_percentage;
      }
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    updateFailed: (state, action: PayloadAction<string>) => {
      state.updating = false;
      state.updateError = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    clearUpdateStatus: (state) => {
      state.updateError = null;
      state.updateSuccess = null;
    },
  },
});

export const vendorCommission = slice.reducer;
export const {
  fetchStart,
  fetchSuccess,
  fetchFailed,
  updateStart,
  updateSuccess,
  updateFailed,
  clearUpdateStatus,
} = slice.actions;
